import { Typography } from '@mui/material';
import { styled } from '@mui/material';
import { Theme } from '@mui/system';

export const ErrorMessage = styled(Typography)(({ theme }: { theme: Theme }) => ({
  color: '#ef5350',
  fontSize: '14px',
  fontWeight: 400
}));
